import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    button: {
      color: COLORS.gray.black,
      fontWeight: theme.typography.fontWeightRegular,
      border: theme.shape.borderGray70,
      padding: theme.spacing(0.625, 1),

      maxWidth: 300,

      // internal <span> wrapping "children" in `CustomButton` component
      '& > span > span': {
        overflow: 'hidden',

        // <span> element of `TruncatedSpan` component
        '& > span': {
          display: 'block',
        },
      },
    },
    chevronIcon: {
      color: COLORS.gray.gray40,
    },
  }),
  { name: 'FooterInstructions' }
);
